<template>
  <div>
    <appModal></appModal>
    <appHeader></appHeader>
    <div class="container-fluid add-new-product">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Fill</h4>
            <div>
              <div
                class="my-2 p-2"
                :key="newMsg.message"
                :style="`border: 1px solid ${newMsg.color}; color: ${newMsg.color}`"
                v-if="newMsg.message"
              >
                <b v-html="newMsg.message"> </b>
              </div>
              <div
                class="my-2 p-2"
                :style="`border: 1px solid ${msg.color}; color: ${msg.color}`"
                v-if="!newMsg.message && msg.message"
              >
                <b v-html="msg.message"> </b>
              </div>
              <div class="d-flex flex-column">
                <div class="d-flex mx-3 mt-3">
                  <div class="d-flex flex-column flex-fill">
                    <h3><strong>Total Breakage Report</strong></h3>
                    <b-container fluid>
                      <b-row :key="report.totalExposure" id="total-exposure">
                        <b-col
                          >Total Exposure
                          <button
                            v-b-tooltip.hover
                            title="Sum of all not activated, unexpired gift cards issued."
                            class="border-0"
                          >
                            <font-awesome-icon size="xs" icon="question" />
                          </button>
                        </b-col>
                        <b-col cols="1">$</b-col>
                        <b-col>{{ report.totalExposure.toFixed(2) }}</b-col>
                      </b-row>
                      <b-row id="cards-outstanding">
                        <b-col>Cards Outstanding</b-col>
                        <b-col cols="1">#</b-col>
                        <b-col>{{ report.cardsOutstanding }}</b-col>
                      </b-row>
                      <b-row id="expire-label">
                        <b-col>Expiring in the next:</b-col>
                      </b-row>
                      <b-row
                        class=""
                        v-for="time in expirationStamps"
                        v-bind:key="time"
                      >
                        <b-col>&emsp;{{ time }} days</b-col>
                        <b-col cols="1">$</b-col>
                        <b-col>{{
                          report[`cardsExpiring${time}days`].toFixed(2)
                        }}</b-col>
                      </b-row>
                    </b-container>
                  </div>
                  <div
                    class="d-flex flex-column mt-5 flex-fill border-left px-3"
                  >
                    <b-container fluid>
                      <b-row>
                        <b-col> Breakage Captured: </b-col>
                        <b-col cols="1">$</b-col>
                        <b-col>{{ report.breakageSum.toFixed(2) }}</b-col>
                      </b-row>
                      <b-row>
                        <b-col> Cards Captured </b-col>
                        <b-col id="filler" cols="1"></b-col>
                        <b-col
                          >{{ report.percentBreakageCount.toFixed(2) }}%</b-col
                        >
                      </b-row>
                      <b-row>
                        <b-col> Breakage Captured </b-col>
                        <b-col id="filler" cols="1"></b-col>
                        <b-col
                          >{{ report.percentBreakageSum.toFixed(2) }}%</b-col
                        >
                      </b-row>
                    </b-container>
                  </div>
                  <div id="filler" class="flex-fill"></div>
                  <div class="mt-4 d-flex flex-column">
                    <h6>Current Tango Balance: ${{ report.tangoBalance }}</h6>
                  </div>
                </div>
                <div
                  id="search-report-section"
                  class="
                    d-flex
                    flex-column
                    border-top
                    mt-3
                    flex-gap
                    align-items-center
                  "
                >
                  <h3 class="mx-3 mt-3 align-self-start">Search By:</h3>
                  <div
                    id="createdSearch"
                    class="
                      d-flex
                      align-items-center align-self-stretch
                      justify-content-center
                      flex-gap
                    "
                  >
                    <p class="">
                      Card Created Date Range:
                    </p>
                    <b-datepicker
                      today-button
                      v-model="filter.creationFromDate"
                      class="w-25"
                    ></b-datepicker>
                    <b-datepicker
                      today-button
                      v-model="filter.creationToDate"
                      class="w-25"
                    ></b-datepicker>
                  </div>
                  <div id="status-filter" class="d-flex flex-gap mt-3">
                    <p>Card Status:</p>
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <b-form-checkbox-group
                        id="checkbox-group-1"
                        v-model="filter.status"
                        :options="statusOptions"
                        :aria-describedby="ariaDescribedby"
                        name="flavour-1"
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </div>
                  <div
                    id="keywords-filter"
                    class="d-flex flex-column w-50 mt-3"
                  >
                    <div
                      id="keywords-filter-options"
                      class="d-flex flex-gap mt-3"
                    >
                      <p>Filter On:</p>
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group
                          id="checkbox-group-2"
                          :options="keywordFilterOptions"
                          :aria-describedby="ariaDescribedby"
                          name="flavour-1"
                          v-model="filter.keywordFields"
                        ></b-form-checkbox-group>
                      </b-form-group>
                    </div>
                    <div class="d-flex flex-gap mb-3">
                      <p>Keywords:</p>
                      <b-input
                        type="search"
                        v-model="filter.keywords"
                        placeholder="keywords"
                        debounce="500"
                      />
                    </div>
                  </div>
                </div>
                <div id="cards-list" class="overflow-auto border-top py-3">
                  <download-csv
                    class="btn btn-default float-right border bg-primary text-white"
                    :data="csvData"
                    :name="csvFileName"
                    :fields="csvFields"
                    :advanced-options="{columns:csvFields}"
                  >
                    CSV Report
                  </download-csv>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <b-table
                    sort-icon-left
                    :per-page="perPage"
                    :current-page="currentPage"
                    :fields="fields"
                    :items="cards"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    @filtered="onFiltered"
                    :filter-function="customFilterTable"
                  >
                  </b-table>
                </div>
              </div>
              <div class="container-fluid">
                <router-view />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>


<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import divvyAdminModal from "@/components/divvyAdminModal.vue";
import {
  getBreakageReport,
  getCardsAdvancedSearch,
} from "../../../api/divvy-breakagReport";

export default {
  name: "BreakageReport",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    appModal: divvyAdminModal,
  },
  data() {
    return {
      newMsg: { color: "red", message: "" },
      msg: {},
      expirationStamps: [30, 60, 90, 120],
      report: {},
      statusOptions: [
        { text: "pending", value: "PENDING" },
        { text: "active", value: "ACTIVE" },
        { text: "expired", value: "EXPIRED" },
        { text: "cancelled", value: "CANCELLED" },
        { text: "error", value: "ERROR" },
      ],
      keywordFilterOptions: [
        { text: "User Name", value: "userName" },
        { text: "Email", value: "userEmail" },
        { text: "Order Number", value: "orderId" },
        { text: "Currency", value: "currency" },
        { text: "Card Value", value: "value" },
      ],

      csvData : [],
      csvFileName : `Cards-${new Date().toLocaleString()}.csv`,

      // Table data
      cards: [],
      fields: [
        { key: "userName", sortable: true },
        { key: "userEmail", sortable: false },
        { key: "creationTimestamp", sortable: true },
        { key: "expirationTimestamp", sortable: true },
        { key: "value", sortable: true },
        { key: "currency", sortable: true },
        { key: "status", sortable: true },
        { key: "orderId", sortable: false },
      ],

      csvFields: ["userName", "userEmail", "creationTimestamp", "expirationTimestamp", "value", "currency", "status", "orderId", "referenceOrderID"],
      

      // sorting and pagination data
      perPage: 5,
      currentPage: 1,
      totalRows: 0,
      sortBy: "age",
      sortDesc: false,

      // filtering data
      filter: {
        keywords: "",
        status: [],
        keywordFields: [
          "userName",
          "userEmail",
          "orderId",
          "currency",
          "value",
        ],
        creationFromDate: null,
        creationToDate: null,
      },
    };
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.csvData = filteredItems;
    },
    setActiveMenuItem: function () {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "breakageReport",
        activeMenu: this.activeMenu ? this.activeMenu : "account",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    customFilterTable(row, filter) {
      let statusCheck = false;
      let keywordCheck = false;
      let creationDateCheck = false;

      // filter on status
      if (filter.status.includes(row.status) || filter.status.length == 0) {
        statusCheck = true;
      }

      // filter on keywords
      // TODO allow use of comma delimited search terms
      if (filter.keywords) {
        for (let field of filter.keywordFields) {
          if (
            (row[field] &&
              typeof row[field] == "string" &&
              row[field]
                .toUpperCase()
                .includes(filter.keywords.toUpperCase())) ||
            (typeof row[field] == "number" && row[field] == filter.keywords)
          ) {
            keywordCheck = true;
            break; // row already met one criteria, no need to continue checking
          }
        }
      } else {
        keywordCheck = true;
      }

      // filter on creation date
      if (filter.creationFromDate || filter.creationToDate) {
        // replacing with hyphens so it follows the lcoale timezone
        const toDate = filter.creationToDate
          ? new Date(filter.creationToDate.replace(/-/g, "/"))
          : new Date();
        toDate.setHours(23, 59, 59, 999); // get end of day)
        const fromDate = filter.creationFromDate
          ? new Date(filter.creationFromDate.replace(/-/g, "/"))
          : new Date(0);
        const creationDate = new Date(row.creationTimestamp).getTime();

        // convert to times
        const tD = toDate.getTime();
        const fD = fromDate.getTime();

        if (creationDate >= fD && creationDate <= tD) {
          creationDateCheck = true;
        }
      } else {
        creationDateCheck = true;
      }

      return statusCheck && keywordCheck && creationDateCheck;
    },
  },
  async mounted() {
    try {
      this.report = await getBreakageReport();
    } catch (e) {
      newMsg.message = `${e}`;
      console.error(e);
    }

    try {
      // get all cards in db
      this.cards = await getCardsAdvancedSearch();
      this.csvData = this.cards;
      this.totalRows = this.cards.length;
    } catch (e) {
      newMsg.message = `${e}`;
      console.error(e);
    }
  },
  async created() {
    this.setActiveMenuItem();
    this.scrollToTop();
  },
};
</script>
<style lang="scss" scoped>
.add-new-product {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}
.flex-label {
  flex: 2 1 25%;
}

.flex-gap {
  gap: 10px;
}

html,
body {
  height: 100%;
}
</style>